// extracted by mini-css-extract-plugin
export default {"main":"CocktailImage_main__4zVRW","favIcon":"CocktailImage_favIcon__EEisY","loading":"CocktailImage_loading__lTCDA","image":"CocktailImage_image__usiNA"};